import TasksView from "@/modules/tasks/components/tasks-view/tasks-view";
import TaskDetailsSidebar from "@/modules/tasks/components/task-details/task-details-sidebar";
import useLeadTasks from "../../hooks/lead-tasks";
import AddLeadTask from "./add-lead-task";
import GenericAccordion from "@/modules/common/components/ui-kit/generic-accordion";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";

const LeadTasks = () => {
  const theme = useTheme();
  const {
    isLoading,
    tasks,
    completingTaskId,
    selectedTask,
    isSidebarOpen,
    openTask,
    closeSidebar,
    handleMarkComplete,
  } = useLeadTasks();

  return (
    <>
      <GenericAccordion title="Tasks" id="lead-tasks" defaultExpanded rounded>
        <Stack spacing={theme.nawy.spacing.md}>
          <TasksView
            isLoading={isLoading}
            tasks={tasks}
            completingTaskId={completingTaskId}
            onTaskClick={openTask}
            onMarkComplete={handleMarkComplete}
          />

          <AddLeadTask />
        </Stack>
      </GenericAccordion>

      <TaskDetailsSidebar
        task={selectedTask}
        isOpen={isSidebarOpen}
        onClose={closeSidebar}
        onMarkAsDone={handleMarkComplete}
        isUpdating={completingTaskId !== null}
      />
    </>
  );
};

export default LeadTasks;
